export const DATA_REFETCHING_INTERVAL_MS = 5000; // 5 seconds
